/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
// Temporary.  The marketing feature flags stuff should be rolled into a feature flags service provider to the FeatureFlagsService instead
// of having its own implementation
var MktFeatureFlags = /** @class */ (function () {
    function MktFeatureFlags(featureStatesMap, caseInsensitiveKeys) {
        this.featureStatesMap = featureStatesMap;
        this.caseInsensitiveKeys = caseInsensitiveKeys;
        if (!this.featureStatesMap) {
            this.featureStatesMap = new Map();
        }
    }
    MktFeatureFlags.prototype.isFeatureEnabled = function (featureName, defaultValue) {
        var _a, _b;
        if (this.caseInsensitiveKeys) {
            featureName = featureName.toLowerCase();
        }
        var value = this.getFeatureFromLocalStorage(featureName);
        if (value != null) {
            return value;
        }
        if (!((_a = this.featureStatesMap) === null || _a === void 0 ? void 0 : _a.has(featureName))) {
            return !!defaultValue;
        }
        return !!((_b = this.featureStatesMap) === null || _b === void 0 ? void 0 : _b.get(featureName));
    };
    MktFeatureFlags.prototype.entries = function () {
        var _a;
        return (_a = this.featureStatesMap) === null || _a === void 0 ? void 0 : _a.entries();
    };
    MktFeatureFlags.prototype.getFeatureFromLocalStorage = function (featureName) {
        var value = localStorage.getItem("FEATURE_".concat(featureName));
        if (!value) {
            return null;
        }
        try {
            return !!JSON.parse(value);
        }
        catch (e) {
            console.warn("Could not parse feature ".concat(featureName, " value from local storage: ").concat(value), e);
            return null;
        }
    };
    return MktFeatureFlags;
}());
export { MktFeatureFlags };
